module.exports = __webpack_public_path__ + "static/media/help-icon.a58c1c7e.svg";